import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=6e5abfff&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=6e5abfff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5abfff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e5abfff')) {
      api.createRecord('6e5abfff', component.options)
    } else {
      api.reload('6e5abfff', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=6e5abfff&scoped=true&", function () {
      api.rerender('6e5abfff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wu21Z1sL3wNk/JS/comp/PopupDialog.vue"
export default component.exports